import { Component, Input } from '@angular/core'
import { ColumnConfig } from '../table.component'
import { FormGroup } from '@angular/forms'

@Component({
  selector: 'app-table-header-cell',
  templateUrl: './table-header-cell.component.html'
})
export class TableHeaderCellComponent {
  @Input() filterForm: FormGroup
  @Input() column: ColumnConfig<any>

  stopPropagation(event: Event) {
    event.stopPropagation()
  }

  clearDatepicker(column: string) {
    this.filterForm.get(column).setValue(null)
  }
}
